export default __webpack_public_path__ + "static/media/APDP_JC.ac83608f.png";